import React, { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import cn from 'clsx';
import T from 'i18n-react';
import { useHistory } from 'react-router-dom';
import ATable from 'components/Antd/Table';
import DocumentFunctionBar from 'views/DocumentManagement/components/FunctionBar';
import { MODULE_TEXT, ITEM_TYPE } from 'views/DocumentManagement/components/FunctionBar/constants';
import { getColumns, OTHER_FIELDS } from './constants';
import classes from './Jobs.module.scss';

const Jobs = ({
  loadJobs,
  jobObj,
  selectedRowKeys,
  setSelectedRowKeys,
  selectedRows,
  setSelectedRows,
  functionBarItems,
  actions,
  typeOptions,
  onReview,
  onUpdateDocument,
  isFolder,
  isArchive,
  onSelectFolder,
  selectedFolder,
  isArchivedTab,
  defaultSelectedFolders,
  onLoadFiles,
}) => {
  const history = useHistory();
  const tPagination = jobObj?.pagination || {};
  const tJobs = (jobObj?.list || [])
    .map((obj) => {
      const documentList = obj.documentList || {};
      const otherData = {};
      OTHER_FIELDS.map((tKey) => {
        otherData[tKey] = obj?.documentList?.documentListIndex?.[tKey];
      });
      return {
        ...obj,
        ...documentList,
        ...otherData,
        isFolder: isEmpty(documentList),
        name: documentList.name || obj.folderName,
        id: documentList.id || obj.id,
        originalId: obj.id,
      };
    })
    .map((obj) => {
      return {
        ...obj,
        name: !obj.isFolder ? obj.name : <span className={classes.folderName}>{obj.name}</span>,
      };
    });
  const onChange = loadJobs;
  const columns = getColumns({ onReview, onUpdateDocument });

  return (
    <div className={classes.wrapper}>
      {selectedRows.length > 0 && (
        <DocumentFunctionBar
          className={classes.functionBar}
          onReset={() => {
            setSelectedRowKeys([]);
            setSelectedRows([]);
          }}
          displayItems={functionBarItems}
          selectedRows={selectedRows}
          actions={actions}
          typeOptions={typeOptions}
          module={MODULE_TEXT.PRODUCT_PROFILE}
          settings={{
            disabledMove: isArchive,
            disables: {
              [ITEM_TYPE.MOVE]: () => {
                return isArchivedTab;
              },
              [ITEM_TYPE.SET_DATA]: (_, tSelectedRows) => {
                return !(tSelectedRows || []).every((obj) => !obj.isFolder);
              },
              [ITEM_TYPE.SET_DATES]: (_, tSelectedRows) => {
                return (tSelectedRows || []).filter((obj) => obj.isFolder).length > 0;
              },
              [ITEM_TYPE.EDIT_TYPE]: (_, tSelectedRows) => {
                return (tSelectedRows || []).filter((obj) => obj.isFolder).length > 0;
              },
              [ITEM_TYPE.ARCHIVE]: (_, tSelectedRows) => {
                return (tSelectedRows || []).filter((obj) => obj.isFolder).length > 0;
              },
            },
            colors: {
              [ITEM_TYPE.REMOVE]: 'warning',
            },
          }}
          defaultSelectedFolders={defaultSelectedFolders}
          onLoadFiles={onLoadFiles}
        />
      )}
      <ATable
        box
        rowSelection={{
          selectedRowKeys,
          onChange: (sRowKeys, sRows) => {
            setSelectedRowKeys(sRowKeys);
            setSelectedRows(sRows);
          },
        }}
        className={cn(classes.table)}
        columns={columns}
        dataSource={tJobs.map((obj, index) => ({
          ...obj,
          key: `${obj.id}_${index}`,
        }))}
        onChange={onChange}
        showSorterTooltip={false}
        rowKey="key"
        rowClassName={(record) => (record.isFolder ? 'row-clickable' : '')}
        onRow={(record) => {
          return {
            onClick: (event) => {
              if (!document.getSelection().toString() && record.isFolder) {
                // Handle the click event only if no text is selected
                // Your onClick logic here...
                onSelectFolder(record);
              }
            },
          };
        }}
        pagination={{
          pageSize: tPagination.pageSize || 10,
          current: tPagination.page || 1,
          total: tPagination.total || 0,
          showSizeChanger: true,
          showTotal: (_, range) => {
            return (
              <div>
                {range[0]}-{range[1]} {T.translate('desktopReview.of')} {tPagination.total || 0}
              </div>
            );
          },
        }}
        sortDirections={['ascend', 'descend', 'ascend']}
        scroll={{
          x: true,
        }}
      />
    </div>
  );
};

export default Jobs;
